module.exports = __webpack_public_path__ + "img/homebanner1.2cb1fd8c.png";